import { render } from "./NewRowPartnerSites.vue?vue&type=template&id=f20b6758"
import script from "./NewRowPartnerSites.vue?vue&type=script&lang=js"
export * from "./NewRowPartnerSites.vue?vue&type=script&lang=js"

import exportComponent from "/builds/linkbuilding-crm/crm-v2-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__